import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link, withRouter } from 'react-router-dom'
import selectors from '../../../../store/shared/selectors'
import { logOutCurrentUser } from '../../../../store/shared/currentUserDuck'
import sbLogoSource from '../../../../assets/logos/sbLogoWordOnly_160w.png'
import * as FullStory from '@fullstory/browser'

export class NavBar extends Component {
  static propTypes = {
    history: PropTypes.any.isRequired,
    logOutCurrentUser: PropTypes.func.isRequired,
    user: PropTypes.any,
    noActions: PropTypes.bool,
  }

  static defaultProps = {
    noActions: false,
  }

  _handleLogOut = () => {
    FullStory.anonymize()
    FullStory.shutdown()
    this.props.logOutCurrentUser()
    this.props.history.push('/')
  }

  _renderAuthenticatedLinks = () => (
    <li className="nav-item" onClick={this._handleLogOut}>
      <span className="text-primary btn btn-sm">Log Out</span>
    </li>
  )

  _renderUnauthenticatedLinks = () => (
    <div className="justify-content-end mt-2" style={{ display: 'inherit' }}>
      <li className="nav-item">
        <Link to={{ pathname: '/login', search: this.props.history.location.search }}>
          <span className="text-primary btn btn-sm">Login</span>
        </Link>
      </li>

      <li className="nav-item">
        <Link to={{ pathname: '/signup', search: this.props.history.location.search }}>
          <button className="btn btn-success btn-sm">Sign Up</button>
        </Link>
      </li>
    </div>
  )

  render() {
    const { noActions, user } = this.props
    return (
      <nav
        className="navbar navbar-expand-md navbar-light shadow"
        style={{ backgroundColor: 'white' }}
      >
        <div className="container mb-0">
          <a href="/" className="navbar-brand">
            <img src={sbLogoSource} alt="Steppingblocks Logo" style={{ width: '160px' }} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            id="navbarNavDropdown"
            className="navbar-collapse collapse flex-row justify-content-end"
          >
            {!noActions && (
              <ul className="nav navbar-nav navbar-right">
                {user ? this._renderAuthenticatedLinks() : this._renderUnauthenticatedLinks()}
              </ul>
            )}
          </div>
        </div>
      </nav>
    )
  }
}

const mapStateToProps = state => ({
  user: selectors.getCurrentUser(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      logOutCurrentUser,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavBar))



// WEBPACK FOOTER //
// ./src/components/ui/navigation/NavBar/index.js